import React, { createContext, useState, useContext, useEffect } from "react";
import apiClient from "../../../../../Config/apiClient"; 
import { jwtDecode } from "jwt-decode";
import { retrieve } from "../../../../../Services/localStorageService";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    try {
      const token = retrieve("accessToken");
      if (!token) return;
      const decoded = jwtDecode(token);
      if (!decoded?.id) return;

      const res = await apiClient.get(
        `${process.env.REACT_APP_HS_NOTIFICATIONS_BASE_PATH}/list`,
        { params: { to_user: decoded.id } }
      );

      if (res.data.status === "SUCCESS") {
        const unread = (res.data.data || []).filter(n => !n.is_read).length;
        setUnreadCount(unread);
      }
    } catch (err) {
      console.error("Error fetching unread count", err);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationContext.Provider value={{ unreadCount, setUnreadCount, fetchUnreadCount }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
